import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { _AccountINFORPO, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { AdminService } from "../../../../../core/services/AdminService";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC007 = ({ configProcedure }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AccountINFORPO)

    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(`Se seleccion el Codeudor`)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ IDAccountCoDeudor: bean.IDAccount, IDCreditAffiliateCoDeudor: bean.IDCreditAffiliate })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }

    }

    const getAffiliate = () => {
        instance.searchCreditAffiliateByNit(parseInt(filter.Nit)).then(
            (resp) => {
                console.log(resp)
                let x = [];
                x.push(
                    {
                        DataBeanProperties: resp,

                    }
                )
                setLista(x)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const [filter, setFilter] = useState<any>({});
    const paginador = usePaginator();

    const limpiar = () => {
        setFilter({ Nit: null, Name: null, Surname: null });
    }


    const head = [
        { title: 'ID', property: 'IDCreditAffiliate', visible: false },
        { title: 'Identificacion', property: 'Nit' },
        { title: 'Nombre', property: 'Entityname' },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md">
                        <div className="input-group">
                            <input placeholder='Identificación' type="text" name="identificacion" id="Identificacion"
                                className='form-control text-uppercase' value={filter.Nit ?? undefined} onChange={(e) => { setFilter({ ...filter, "Nit": e.target.value }) }} />
                            {/* <input placeholder='Nombre' type="text" name="nombre" id="nombre"
                                className='form-control text-uppercase' value={filter.Name ?? undefined} onChange={(e) => { setFilter({ ...filter, "Name": e.target.value }) }} />
                            <input placeholder='Apellido' type="text" name="apellido" id="apellido"
                                className='form-control text-uppercase' value={filter.Surname ?? undefined} onChange={(e) => { setFilter({ ...filter, "Surname": e.target.value }) }} /> */}

                            <button className="btn btn-success" type="button" onClick={() => {
                                getAffiliate();
                            }}>Buscar</button>
                            <button className="btn btn-danger" type="button" onClick={limpiar}>Limpiar</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4">
                        <BasicTable
                            head={head}
                            body={lista}
                            rowSet={setBean}
                            pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                        />
                    </div>
                </div>
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={`Seleccionar`} />
            </div>
        </div>
    );
};